import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.button`
  background: #e80000;
  height: 55px;
  border-radius: 8px;
  border: 0;
  padding: 0 16px;
  color: #fff;
  width: 100%;
  font-weight: bold;
  margin-top: 16px;
  transition: all 0.2s;

  &:hover {
    background: ${shade(0.2, '#e80000')};
  }

  &:disabled {
    background: #dcdcdc;
  }
`;
